import { Spin } from "antd";
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import {
  buildAdvancedChartEmbedUrl,
  preloadTradingViewScript,
} from "../../../../../../../../utils/tradingViewLoader";
import styles from "./TradingViewWidget.module.css";

function resolveTradingViewSymbol(symbol: string): string {
  const normalized = symbol.trim().toUpperCase();
  if (!normalized) return "NASDAQ:AAPL";
  return normalized.includes(":") ? normalized : normalized;
}

function TradingViewWidget({ symbol }: { symbol: string }) {
  const [isChartLoading, setIsChartLoading] = useState(true);

  const displaySymbol = symbol.includes(":")
    ? symbol.split(":")[1]?.toUpperCase() || symbol.toUpperCase()
    : symbol.toUpperCase();

  const tradingViewSymbol = useMemo(
    () => resolveTradingViewSymbol(symbol),
    [symbol],
  );

  const tradingViewUrlSymbol = symbol.includes(":")
    ? symbol.replace(":", "-").toUpperCase()
    : symbol.toUpperCase();

  const iframeSrc = useMemo(
    () => buildAdvancedChartEmbedUrl(tradingViewSymbol),
    [tradingViewSymbol],
  );

  useEffect(() => {
    preloadTradingViewScript();
  }, []);

  useEffect(() => {
    setIsChartLoading(true);
  }, [iframeSrc]);

  const handleLoad = useCallback(() => {
    setIsChartLoading(false);
  }, []);

  return (
    <div className={`tradingview-widget-container ${styles.root}`}>
      <div className={styles.widgetShell}>
        {isChartLoading && (
          <div className={styles.loadingOverlay} aria-hidden={!isChartLoading}>
            <Spin />
          </div>
        )}
        <iframe
          key={iframeSrc}
          src={iframeSrc}
          title={`${displaySymbol} stock chart`}
          className={styles.chartFrame}
          loading="eager"
          referrerPolicy="no-referrer-when-downgrade"
          onLoad={handleLoad}
        />
      </div>
      <div className={`tradingview-widget-copyright ${styles.copyright}`}>
        <a
          href={`https://www.tradingview.com/symbols/${tradingViewUrlSymbol}/`}
          rel="noopener nofollow"
          target="_blank"
        >
          <span className="blue-text">{displaySymbol} stock chart</span>
        </a>
        <span className="trademark"> by TradingView</span>
      </div>
    </div>
  );
}

export default memo(TradingViewWidget);
